import { Controller } from "@hotwired/stimulus"

// Stimulus controller for dashboard widgets.
//
// Currently handles ApexCharts initialization for chart widgets.
// Expects the chart options JSON in a data attribute.
//
// Usage (set automatically by the chart_widget partial):
//   <div data-controller="dashboard-widget"
//        data-dashboard-widget-chart-options-value='{ ... }'>
//   </div>
//
// NOTE: ApexCharts must be installed in the project:
//   yarn add apexcharts
//
// Then import it in entrypoints/application.js:
//   import ApexCharts from 'apexcharts'
//   window.ApexCharts = ApexCharts

export default class extends Controller {
  static values = {
    chartOptions: { type: Object, default: {} }
  }

  connect() {
    if (Object.keys(this.chartOptionsValue).length > 0) {
      this.initChart()
    }
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  initChart() {
    if (typeof window.ApexCharts === 'undefined') {
      console.warn(
        'dashboard-widget: ApexCharts is not loaded. ' +
        'Install it with `yarn add apexcharts` and expose it as window.ApexCharts.'
      )
      const notice = document.createElement('div')
      notice.className = 'text-center text-muted py-4'
      notice.textContent = 'ApexCharts not installed.'
      this.element.replaceChildren(notice)
      return
    }

    this.chart = new window.ApexCharts(this.element, this.chartOptionsValue)
    this.chart.render()
  }
}
